import {Injectable} from '@angular/core';
import {InfoService} from '../section-service.class';
import {Service} from '../../common/service.class';
import {Observable} from 'rxjs';
import {State} from './state.model';
import {CountryProjection} from './country-projection.model';

/**
 * Created by Rodrigo Quesada on 12/12/16.
 */
@Injectable()
export class CountryService extends InfoService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'country');
    }

    getCountriesProjection(): Observable<Array<CountryProjection>> {
        return this.getList(CountryProjection);
    }

    getStates(): Observable<Array<State>> {
        return this.getList(State);
    }

    getStatesForCountry(countryCode: string): Observable<Array<State>> {
        return this.getList(State, countryCode);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/country/country.service.ts